import { FunctionComponent } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const siteUrl = (
  process.env.REACT_APP_SITE_URL ?? "https://chytanka.com"
).replace(/\/+$/, "");

interface SeoProps {
  title: string;
  description: string;
  /**
   * Absolute URL or path to declare as canonical. Defaults to the current
   * route, so every page is self-referencing unless it opts out.
   */
  canonical?: string;
  noindex?: boolean;
}

const buildCanonical = (path: string) => {
  if (/^https?:\/\//.test(path)) return path;
  const normalized = path.replace(/\/+$/, "");
  return `${siteUrl}${normalized === "" ? "/" : normalized}`;
};

const Seo: FunctionComponent<SeoProps> = ({
  description,
  title,
  canonical,
  noindex = false,
}) => {
  const { pathname } = useLocation();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={buildCanonical(canonical ?? pathname)} />
      <meta
        name="robots"
        content={noindex ? "noindex, follow" : "index, follow"}
      />
    </Helmet>
  );
};

export default Seo;
